export default "__VITE_ASSET__BWW$2gnj__"